import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter, tap } from 'rxjs/operators';

interface Window {
  dataLayer: any[];
}

@Injectable({
    providedIn: 'root'
})
export class GTMService {
    constructor(private router: Router) {
        // Listen to router navigation events
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd),
            tap((event: NavigationEnd) => {
                this.pushPageView(event.urlAfterRedirects);
            })
        ).subscribe();
    }

    // Push a pageview event to GTM dataLayer
    private pushPageView(url: string) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'pageview',
            page_path: url,
            page_title: document.title // Optional: Customize based on route
        });
    }

    // Push custom events to GTM (e.g., form submissions)
    pushEvent(eventName: string, eventData: any) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: eventName,
            ...eventData
        });
    }
}